import { BaseTable } from '@old/ui/table';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid-pro';
import { formatDate } from '@old/utils/helper';
import { Stack, Box, Typography, IconButton, Tooltip } from '@mui/material';
import IconSiloID from '@old/assets/svg/siloreal/product-silo-id.svg';
import IconSiloMetrix from '@old/assets/svg/siloreal/product-silo-metrix.svg';
import { useNavigate } from 'react-router';
import { PATH } from '@old/data/core/paths';
import NewReleaseIcon from '@old/assets/svg/SiloBagPage/new_releases.svg';
import NewReleaseIconDisabled from '@old/assets/svg/SiloBagPage/new-release-disabled.svg';
import { useState } from 'react';
import i18n from '../../libs/language';
import { lancePositions } from '@old/utils/helper';
import { PoeModal } from '@old/features/silobags/silobag-detail/section-history/poe-silobag-modal';
import BlueViewIcon from '@old/assets/svg/SiloBagPage/view/eye-blue.svg';
import ChevronRight from '@old/assets/svg/chevron-right.svg';
import { stockStatusListService } from '@old/services/domain/page/report/status-stock/report-status-stock.info';
import { silobagDataDetailService } from '@old/services/domain/base/silobag/base/silobag-data-detail';
import { PoeV2SilobagModal } from '@old/features/silobags/silobag-detail/section-history/poe-v2-silobag-modal';
import * as HOOKS from '@siloreal:shared:hooks';

type PoeSummary = Awaited<ReturnType<typeof silobagDataDetailService>>['summary']['poe'];

type SummaryType = Awaited<ReturnType<typeof stockStatusListService>>['summary'];

type Poe2Summary = Awaited<
  ReturnType<typeof silobagDataDetailService>
>['summary']['silobags_history'][0]['poe_v2'];

type PaginationModal = {
  page: number;
  pageSize: number;
};

type PoeStatusType = {
  [key: number]: {
    status: string;
    color: string;
  };
};

type StateStockProps = {
  data: SummaryType['rows'];
  isLoading: boolean;
  count: number;
  paginationModel?: PaginationModal;
  setPaginationModel?: (fn: (model: GridPaginationModel) => GridPaginationModel) => void;
};

export const TabletStateStock = (props: StateStockProps) => {
  const { data, isLoading, count, paginationModel, setPaginationModel } = props;
  const navigate = useNavigate();
  const [modalPoe, setModalPoe] = useState(false);
  const [modalPoe2, setModalPoe2] = useState(false);

  const [eventId, setEventId] = useState<number>();
  const [dataPoe, setDataPoe] = useState<PoeSummary | null>();
  const [poe2Data, setPoe2Data] = useState<Poe2Summary>();

  const stateDataParsed = data?.map((item) => ({
    ...item,
    initial_humidity:
      typeof item.initial_humidity === 'string' ? parseFloat(item.initial_humidity) : item.initial_humidity,
    first_sbd_first_measurement_heg:
      item.first_sbd_first_measurement_heg !== null ? parseFloat(item.first_sbd_first_measurement_heg) : null,
    second_sbd_first_measurement_heg:
      item.second_sbd_first_measurement_heg !== null
        ? parseFloat(item.second_sbd_first_measurement_heg)
        : null,
    third_sbd_first_measurement_heg:
      item.third_sbd_first_measurement_heg !== null ? parseFloat(item.third_sbd_first_measurement_heg) : null,
  }));

  const handleOpenPoe = (event_id: number, data: PoeSummary | null) => {
    setModalPoe(true);
    setEventId(event_id);
    setDataPoe(data);
  };
  //Objeto con los estados de los POE || recorrida
  const PoeStatus: PoeStatusType = {
    1: { status: i18n.t('app.silobag_history.Optimum'), color: '#73BD00' },
    2: { status: i18n.t('app.silobag_history.precaution'), color: '#E6EA02' },
    3: { status: i18n.t('app.state_stock_page.risk_elevate'), color: 'orange' },
    4: { status: i18n.t('app.silobag_history.critical'), color: 'red' },
  };
  //funcion para generar el contenido del tooltip
  const generateTooltipContent = (
    lanceNumber: string,
    position: string,
    date: string,
    lastMetric: number | null
  ) => {
    const contentTooltip = {
      lanceNumber: i18n.t('app.state_stock_page.lance_id') + ': ' + lanceNumber,
      position: i18n.t('app.state_stock_page.position') + ': ' + lancePositions[position as '1'],
      date: i18n.t('app.date') + ': ' + formatDate(date, true),
      lastMetric:
        lastMetric !== null
          ? i18n.t('app.state_stock_page.last_metric') + lastMetric + '%'
          : i18n.t('app.state_stock_page.no_last_metric'),
    };

    return Object.entries(contentTooltip).map(([key, value]) => <p key={key}>{value}</p>);
  };

  const i18n_new = HOOKS.useLocale();

  const handleClosePoe2Modal = () => setModalPoe2(false);

  const handleOpenPoe2 = (poe_data: Poe2Summary) => {
    setModalPoe2(true);
    setPoe2Data(poe_data);
    setEventId(33);
  };
  const columns: GridColDef[] = [
    {
      field: 'id',
      display: 'flex',
      sortable: false,
      flex: 0.8,
      minWidth: 90,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          ID Silo
        </Typography>
      ),
      renderCell: (params) => {
        const siloId = params.value;
        return (
          <Box component="div" style={{ display: 'flex', alignItems: 'center' }}>
            <Stack
              width={'100%'}
              alignItems={'center'}
              justifyContent={'center'}
              direction={'row'}
              spacing={1}
            >
              <Typography
                variant="body2"
                style={{
                  fontWeight: 500,
                  fontSize: '13px',
                  color: '#05AADF',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                onClick={() => navigate(`${PATH.SILOBAG}/${siloId}`)}
              >
                {siloId}
              </Typography>
              <img src={ChevronRight} alt="go-to-silo" style={{ paddingTop: 5 }} />
            </Stack>
          </Box>
        );
      },
    },
    {
      field: 'silobag_name',
      display: 'flex',
      flex: 1,
      minWidth: 100,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.silobag')}
        </Typography>
      ),
      renderCell: (params) => {
        const silobagName = params.value;
        return (
          <Typography color={'#49454F'} fontSize={13}>
            {silobagName}
          </Typography>
        );
      },
    },
    {
      field: 'countryside_name',
      display: 'flex',
      flex: 1.4,
      minWidth: 140,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.countrysides')}
        </Typography>
      ),
      renderCell: (params) => {
        const countrysideName = params.value;
        return (
          <Typography color={'#49454F'} fontSize={13}>
            {countrysideName}
          </Typography>
        );
      },
    },
    {
      field: 'lot_name',
      display: 'flex',
      flex: 1,
      minWidth: 140,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.silobag_data.lot_stock')}
        </Typography>
      ),
      renderCell: (params) => {
        const lotName = params.value;
        return (
          <Typography color={'#49454F'} fontSize={13}>
            {lotName}
          </Typography>
        );
      },
    },
    {
      field: 'bagging_date',
      display: 'flex',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      minWidth: 150,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.state_stock_page.date_bagging')}
        </Typography>
      ),
      renderCell: (params) => {
        const certificationSiloSat = params.row.bagging_date_matches;
        const baggingDate = params.value;
        return (
          <Box>
            {baggingDate !== null && (
              <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                <Typography color="#49454F" fontSize={13}>
                  {formatDate(params.value as string)}{' '}
                </Typography>
                {certificationSiloSat !== null && (
                  <Tooltip
                    title={
                      certificationSiloSat
                        ? i18n.t('app.state_stock_page.certificate_silo_sat')
                        : i18n.t('app.state_stock_page.no_certificate_silo_sat')
                    }
                  >
                    <img
                      src={certificationSiloSat ? NewReleaseIcon : NewReleaseIconDisabled}
                      style={{ width: 16, height: 16 }}
                    />
                  </Tooltip>
                )}
              </Stack>
            )}
          </Box>
        );
      },
    },
    {
      field: 'remaining_stock',
      display: 'flex',
      flex: 1,
      headerClassName: 'end-grouping-cell',
      cellClassName: 'end-grouping-cell',
      minWidth: 140,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.silobag_data.remaining_stock')}
        </Typography>
      ),
      renderCell: (params) => {
        return (
          <Typography color={'#49454F'} fontSize={13}>
            {i18n.numberToDelimited(parseFloat(params.value || 0), {
              delimiter: i18n.t('config.delimiter'),
            })}{' '}
            kg
          </Typography>
        );
      },
    },
    {
      field: 'days_since_last_poe',
      display: 'flex',
      align: 'left',
      headerAlign: 'center',
      flex: 1,
      minWidth: 130,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.state_stock_page.date_poe')}
        </Typography>
      ),
      renderCell: (params) => {
        const isPoeExpired = params.row.is_poe_expired;
        const sinceLastPoe = params.value;
        const COLOR = { NORMAL: '#49454F', EXPIRED: '#FF0000' };
        const colorToShow = isPoeExpired ? COLOR.EXPIRED : COLOR.NORMAL;

        return (
          <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
            <Typography color={colorToShow} fontSize={13}>
              {sinceLastPoe} {i18n.t('app.days')}
            </Typography>
            {isPoeExpired && (
              <Typography color={colorToShow} fontSize={11}>
                {i18n.t('app.state_stock_page.expired')}
              </Typography>
            )}
          </Stack>
        );
      },
    },
    {
      field: 'first_poe_status_id',
      display: 'flex',
      flex: 1,
      minWidth: 120,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.state_stock_page.result')}
        </Typography>
      ),
      renderCell: (params) => {
        const fstStatus = PoeStatus[params.value]?.status;
        const sndStatus = params.row.second_poe_status_id;

        const statusColor = PoeStatus[params.value]?.color;

        return (
          <Stack>
            <Stack direction="row" spacing={0.3} alignItems="center">
              <Box
                style={{
                  height: '10px',
                  width: '10px',
                  backgroundColor: statusColor,
                  borderRadius: '50%',
                  marginRight: '3px',
                }}
              />
              <Typography color={statusColor} fontSize={13}>
                {fstStatus}
              </Typography>
            </Stack>
            {sndStatus ? (
              <Typography color="#A1A1A0" fontSize={11}>
                {i18n.t('app.state_stock_page.former')} {PoeStatus[sndStatus]?.status}
              </Typography>
            ) : null}
          </Stack>
        );
      },
    },
    {
      field: 'last_humidity_revision_value',
      display: 'flex',
      flex: 1.4,
      minWidth: 190,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n_new.t('temp.common.last_calado')}
        </Typography>
      ),
      renderCell: (params) => {
        const humidity = params.row.last_humidity_revision_value;
        const date = params.row.last_humidity_revision_date;

        return (
          <Stack>
            <Typography color="#49454F" fontSize={13}>
              {i18n_new.t('temp.common.humidity')}:{' '}
              {humidity !== null && humidity !== undefined ? `${humidity}%` : '-'}
            </Typography>

            <Typography color="#49454F" fontSize={13}>
              {i18n_new.t('temp.common.date')}: {date ? formatDate(date) : '-'}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: 'worse_humidity_revision_value',
      display: 'flex',
      flex: 1.4,
      minWidth: 190,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n_new.t('temp.common.max_quality_revision')}
        </Typography>
      ),
      renderCell: (params) => {
        const humidity = params.row.worse_humidity_revision_value;
        const date = params.row.worse_humidity_revision_date;

        return (
          <Stack>
            <Typography color="#49454F" fontSize={13}>
              {i18n_new.t('temp.common.humidity')}:{' '}
              {humidity !== null && humidity !== undefined ? `${humidity}%` : '-'}
            </Typography>

            <Typography color="#49454F" fontSize={13}>
              {i18n_new.t('temp.common.date')}: {date ? formatDate(date) : '-'}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: 'first_poe_id',
      display: 'flex',
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      flex: 0.6,
      headerClassName: 'end-grouping-cell',
      cellClassName: 'end-grouping-cell',
      minWidth: 80,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.detail')}
        </Typography>
      ),
      renderCell: (params) => {
        const { first_poe_v2, first_poe } = params.row;
        if (first_poe_v2?.id) {
          return (
            <IconButton onClick={() => handleOpenPoe2(first_poe_v2)}>
              <img src={BlueViewIcon} alt="view-icon" style={{ width: '16px', height: '16px' }} />
            </IconButton>
          );
        }
        if (first_poe?.id) {
          return (
            <IconButton onClick={() => handleOpenPoe(first_poe.id, first_poe)}>
              <img src={BlueViewIcon} alt="view-icon" style={{ width: '16px', height: '16px' }} />
            </IconButton>
          );
        }
        return null;
      },
    },
    {
      field: 'initial_humidity',
      display: 'flex',
      flex: 1.2,
      minWidth: 130,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.silobag_data.initial_humidity')}
        </Typography>
      ),
      renderCell: (params) => {
        const initialHumidity = params.value;
        return (
          <Typography
            color="#49454F"
            fontSize={13}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {initialHumidity ? `${initialHumidity} %` : null}
          </Typography>
        );
      },
    },
    {
      field: 'first_sbd_first_measurement_heg',
      display: 'flex',
      flex: 1,
      minWidth: 90,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.state_stock_page.humidity')}
        </Typography>
      ),
      renderCell: (params) => {
        const firstHeg = parseFloat(params.value);
        const secondHeg = params.row.first_sbd_second_measurement_heg;
        const lanceNumber = params.row.first_sbd_lance_number;
        const position = params.row.first_sbd_position;
        const firstMeasurement = params.row.first_sbd_first_measurement_created_at;
        //genero el contenido del tooltip
        const tooltipContentMap = generateTooltipContent(lanceNumber, position, firstMeasurement, secondHeg);
        return (
          <>
            {firstHeg ? (
              <Tooltip title={tooltipContentMap}>
                <>
                  <Typography
                    color="#49454F"
                    fontSize={13}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {firstHeg} %
                  </Typography>
                  <Box
                    style={{
                      height: '10px',
                      width: '10px',
                      backgroundColor: params.row.first_sbd_heg_hex,
                      borderRadius: '50%',
                      marginLeft: '6px',
                    }}
                  />
                </>
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
    {
      field: 'second_sbd_first_measurement_heg',
      display: 'flex',
      flex: 1,
      minWidth: 90,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.state_stock_page.humidity')}
        </Typography>
      ),
      renderCell: (params) => {
        const firstHeg = parseFloat(params.value);
        const secondHeg = params.row.second_sbd_second_measurement_heg;
        const lanceNumber = params.row.second_sbd_lance_number;
        const position = params.row.second_sbd_position;
        const firstMeasurement = params.row.second_sbd_first_measurement_created_at;
        const tooltipContentMap = generateTooltipContent(lanceNumber, position, firstMeasurement, secondHeg);
        return (
          <>
            {firstHeg ? (
              <Tooltip title={tooltipContentMap}>
                <>
                  <Typography
                    color="#49454F"
                    fontSize={13}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {firstHeg}%{' '}
                  </Typography>
                  <Box
                    style={{
                      height: '10px',
                      width: '10px',
                      backgroundColor: params.row.second_sbd_heg_hex,
                      borderRadius: '50%',
                      marginLeft: '6px',
                    }}
                  />
                </>
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
    {
      field: 'third_sbd_first_measurement_heg',
      display: 'flex',
      flex: 1,
      minWidth: 90,
      renderHeader: () => (
        <Typography color="#49454F" fontSize={13} fontWeight={600}>
          {i18n.t('app.state_stock_page.humidity')}
        </Typography>
      ),
      renderCell: (params) => {
        const firstHeg = parseFloat(params.value);
        const secondHeg = parseFloat(params.row.third_sbd_second_measurement_heg);
        const lanceNumber = params.row.last_sbd_lance_number;
        const position = params.row.third_sbd_position;
        const firstMeasurement = params.row.third_sbd_first_measurement_created_at;
        const tooltipContentMap = generateTooltipContent(lanceNumber, position, firstMeasurement, secondHeg);
        return (
          <>
            {firstHeg ? (
              <Tooltip title={tooltipContentMap}>
                <>
                  <Typography
                    color="#49454F"
                    fontSize={13}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {firstHeg}%{' '}
                  </Typography>
                  <Box
                    style={{
                      height: '10px',
                      width: '10px',
                      backgroundColor: params.row.third_sbd_heg_hex,
                      borderRadius: '50%',
                      marginLeft: '6px',
                    }}
                  />
                </>
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
  ];

  return (
    <Box style={{ marginTop: '20px', backgroundColor: 'white', borderRadius: '10px' }}>
      <BaseTable
        loading={isLoading}
        rows={stateDataParsed}
        columns={columns}
        initialPageSize={paginationModel?.pageSize ?? 50}
        paginationMode="client"
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        rowCount={count}
        columnGroupingModel={[
          {
            groupId: 'silobag',
            description: 'Silobag',
            headerClassName: 'end-grouping-cell',
            children: [
              { field: 'id' },
              { field: 'silobag_name' },
              { field: 'countryside_name' },
              { field: 'bagging_date' },
              { field: 'remaining_stock' },
              { field: 'lot_name' },
            ],
            renderHeaderGroup: () => (
              <Typography color="#49454F" fontSize={13} fontWeight={600}>
                {i18n.t('app.silobag')}
              </Typography>
            ),
          },
          {
            groupId: 'silo-id',
            description: 'Silo ID',
            headerClassName: 'end-grouping-cell',
            children: [
              { field: 'first_poe_timestamp' },
              { field: 'first_poe_status_id' },
              { field: 'last_humidity_revision_value' },
              { field: 'worse_humidity_revision_value' },
              { field: 'first_poe_id' },
            ],
            renderHeaderGroup: () => (
              <Stack direction="row" spacing={1} alignItems="center">
                <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                  <img src={IconSiloID} alt="siloID-icon" style={{ width: 18, height: 18 }} />
                  <Typography color="#6baa00" display="flex" alignItems="center">
                    SILO <b>ID</b>
                  </Typography>
                </Stack>
                <Typography color={'#49454F'} fontSize={13}>
                  {i18n.t('app.poe_round')}
                </Typography>
              </Stack>
            ),
          },
          {
            groupId: 'silo-metrix',
            description: 'Silo Metrix',
            children: [
              { field: 'initial_humidity' },
              { field: 'first_sbd_first_measurement_heg' },
              { field: 'second_sbd_first_measurement_heg' },
              { field: 'third_sbd_first_measurement_heg' },
            ],
            renderHeaderGroup: () => (
              <Stack direction="row" spacing={1} alignItems="center">
                <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                  <img src={IconSiloMetrix} alt="siloMetrix-icon" style={{ width: 18, height: 18 }} />
                  <Typography color="orange" display="flex" alignItems="center">
                    SILO <b>METRIX</b>
                  </Typography>
                </Stack>
                <Typography color={'#49454F'} fontSize={13}>
                  {i18n.t('app.state_stock_page.humidity')}
                </Typography>
              </Stack>
            ),
          },
        ]}
        sx={{
          '& .end-grouping-cell': { borderRight: '1px solid rgba(224, 224, 224, 1)' },
          '& .MuiDataGrid-columnHeader--filledGroup .MuiDataGrid-columnHeaderTitleContainer': {
            border: 'none', // remove header grouping bottom border
          },
        }}
      />
      {PoeModal && <PoeModal open={modalPoe} setOpen={setModalPoe} data={dataPoe!} poeId={eventId} />}
      {PoeV2SilobagModal && (
        <PoeV2SilobagModal open={modalPoe2} onClose={handleClosePoe2Modal} data={poe2Data} />
      )}
    </Box>
  );
};
